<template>
<div v-show="coupons && coupons.length && doesStoreHaveSetting('showCouponInMenu')" id="CouponCardContainer">
  <RewardsTitle title="Coupons" />

  <v-layout>
    <v-flex row xs12 sm10 offset-sm1>
      <v-layout row wrap grid-list-md class="menuContainer">
        <carousel paginationEnabled>
          <template v-for="(coupon, index) in coupons">
            <slide>
              <v-flex :key="`menu_${index}${coupon.code}`" v-if="isEligible(coupon)" class="hover-animation-container">
                <coupon-card allowConfig :coupon="coupon" max-width="100%" />
              </v-flex>
            </slide>
          </template>
        </carousel>
      </v-layout>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import get from 'lodash/get';

import { mapGetters } from 'vuex'

import storePage from '@/views/StorePage.vue'
import RewardsTitle from "../RewardsOptions/RewardsTitle"

export default {
  extends: storePage,
  components: { RewardsTitle },

  computed: {
    coupons() {
      const orderType = this.getOrderType
      return get(this.getCustomerRewards, 'coupons', []).filter(item => {
        if (!this.passSearch(item)) return false
        if (item.freeDelivery && orderType !== 'DELIVERY') return false
        if (item.validOrderTypes && item.validOrderTypes.length) {
          return item.validOrderTypes.includes(orderType)
        }
        return true
      })
    },

    ...mapGetters([ 'getCustomerRewards', 'doesStoreHaveSetting', 'getOrderType' ])
  },

  methods: {
    isEligible(coupon) {
      if (!(coupon && 'eligibilityResult' in coupon))
        return false

      // DEV-11340: Purchase Coupons is deprecated -- never offer a coupon that's for sale.
      if (!!coupon.charges && !coupon.uuid)
        return false

      return !!(coupon.eligibilityResult.isEligible || coupon.eligibilityResult.shouldShowIfNotEligible)
    }
  }
}
</script>

<style>
  #CouponCardContainer .RewardsCard {
    padding: 5px 10px;
  }
</style>
<style scoped>
  .hover-animation-container {
    padding: 5px 10px;
  }
  .hover-animation-container .CardContainer {
    border: none !important;
  }
</style>
